/**
 * PMGW Custom Bundle Logic
 * Handles bundle removal functionality
 */

(function() {
  'use strict';
  
  // Bundle-Konfiguration - automatisch aus Translations geladen
  const BUNDLE_CONFIG = window.PMGW_BUNDLE_CONFIG || {
    MAIN_PRODUCT_IDS: ['9696831242582'],
    GIFT_PRODUCT_IDS: ['9816755372374', '9720955109718', '9720938758486'],
    GIFT_VALUE_HEADLINE: 'GRATIS MIT DABEI im Wert von'
  };
  
  const MAIN_PRODUCT_IDS = BUNDLE_CONFIG.MAIN_PRODUCT_IDS;
  const GIFT_PRODUCT_IDS = BUNDLE_CONFIG.GIFT_PRODUCT_IDS;

  // Hilfsfunktion: Prüfe ob Bundle im Cart ist
  function isBundleInCart(cart) {
    const mainProductItems = cart.items.filter(item => 
      MAIN_PRODUCT_IDS.includes(item.product_id.toString())
    );
    
    const mainProductCount = mainProductItems.length;
    const mainProductTotalQuantity = mainProductItems.reduce((total, item) => total + item.quantity, 0);
    
    const giftItems = cart.items.filter(item => 
      GIFT_PRODUCT_IDS.includes(item.product_id.toString()) && 
      item.final_line_price === 0
    );
    
    // Bundle-Detection: Main Product + Gifts im Cart = Bundle (egal ob klein oder groß)
    const hasMainProduct = mainProductCount > 0 && mainProductTotalQuantity > 0;
    const hasGifts = giftItems.length >= 1;
    const isBundle = hasMainProduct && hasGifts;
    
    return isBundle;
  }
  
  // Entferne alle Bundle-Items mit Optimistic UI
  function removeAllBundleItems() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemsToRemove = [];
        let mainProductCount = 0;
        let giftCount = 0;
        
        // Sammle alle Bundle-Items
        cart.items.forEach((item, index) => {
          const productId = item.product_id.toString();
          
          if (MAIN_PRODUCT_IDS.includes(productId)) {
            mainProductCount++;
            itemsToRemove.push({
              type: 'main',
              item: item,
              line: index + 1,
              id: item.key
            });
          } else if (GIFT_PRODUCT_IDS.includes(productId)) {
            giftCount++;
            itemsToRemove.push({
              type: 'gift',
              item: item,
              line: index + 1,
              id: item.key
            });
          }
        });
        
        if (itemsToRemove.length === 0) {
          return Promise.resolve();
        }
        
        // Zeige sofortiges Feedback
        showRemovalFeedback();
        
        // Entferne Items parallel
        return removeItemsInParallel(itemsToRemove);
      });
  }
  
  
  // Zeige Feedback während der Entfernung
  function showRemovalFeedback() {
    // Erstelle temporäre Nachricht
    const feedbackDiv = document.createElement('div');
    feedbackDiv.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #333;
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      font-size: 14px;
      z-index: 10000;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;
    feedbackDiv.textContent = 'Bundle wird entfernt...';
    
    document.body.appendChild(feedbackDiv);
    
    // Fade in
    setTimeout(() => {
      feedbackDiv.style.opacity = '1';
    }, 50);
    
    // Auto-remove nach 2 Sekunden (kürzer da es jetzt schneller geht)
    setTimeout(() => {
      feedbackDiv.style.opacity = '0';
      setTimeout(() => {
        if (feedbackDiv.parentNode) {
          feedbackDiv.parentNode.removeChild(feedbackDiv);
        }
      }, 300);
    }, 2000);
  }
  
  // Entferne alle Items parallel (gleichzeitig)
  function removeItemsInParallel(itemsToRemove) {
    // Erstelle alle Requests parallel
    const removePromises = itemsToRemove.map(item => {
      return fetch(`${window.themeVariables?.routes?.cartChangeUrl || '/cart/change'}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: item.line,
          id: item.id,
          quantity: 0,
          sections: ['mini-cart']
        })
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          // Bei Fehler: null zurückgeben, aber nicht den ganzen Prozess stoppen
          return null;
        }
      })
      .catch(error => {
        // Bei Fehler: null zurückgeben, aber nicht den ganzen Prozess stoppen
        return null;
      });
    });
    
    // Warte auf alle Requests
    return Promise.all(removePromises)
      .then(results => {
        // Finde das letzte erfolgreiche Result für Cart-Update
        const lastSuccessfulResult = results.filter(result => result !== null).pop();
        
        if (lastSuccessfulResult) {
          // Trigger Cart-Update Events
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: lastSuccessfulResult }
          }));
          
          if (lastSuccessfulResult.sections) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { 
                cart: lastSuccessfulResult,
                sections: lastSuccessfulResult.sections
              }
            }));
          }
        }
        
        // Prüfe ob noch Bundle-Items übrig sind (Fallback für fehlgeschlagene Requests)
        return checkForRemainingBundleItems();
      });
  }
  
  // Entferne Items sequenziell mit Focal Theme's cart/change.js API
  function removeItemsSequentiallyWithThemeAPI(itemsToRemove) {
    // Sortiere von hinten nach vorne (höchste Line-Nummern zuerst)
    itemsToRemove.sort((a, b) => b.line - a.line);
    
    return removeNextItemWithThemeAPI(itemsToRemove, 0);
  }
  
  // Entferne das nächste Bundle-Item (rekursiv mit aktuellen Cart-Daten)
  function removeNextItemWithThemeAPI(itemsToRemove, index) {
    if (index >= itemsToRemove.length) {
      return checkForRemainingBundleItems();
    }
    
    const item = itemsToRemove[index];
    
    return fetch(`${window.themeVariables?.routes?.cartChangeUrl || '/cart/change'}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: item.line,
        id: item.id,
        quantity: 0,
        sections: ['mini-cart']
      })
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        return null;
      }
    })
    .then(cartContent => {
      if (cartContent) {
        // Trigger sofortiges Cart-Update Event
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartContent }
        }));
        
        // Trigger Cart-Drawer Refresh Event
        if (cartContent.sections) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { 
              cart: cartContent,
              sections: cartContent.sections
            }
          }));
        }
      }
      
      return new Promise(resolve => {
        setTimeout(() => {
          removeNextItemWithThemeAPI(itemsToRemove, index + 1)
            .then(resolve)
            .catch(resolve);
        }, 150);
      });
    })
    .catch(error => {
      return removeNextItemWithThemeAPI(itemsToRemove, index + 1);
    });
  }
  
  // Prüfe ob noch Bundle-Items im Cart sind und entferne sie
  function checkForRemainingBundleItems() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const remainingBundleItems = [];
        
        cart.items.forEach((item, index) => {
          const productId = item.product_id.toString();
          
          if (MAIN_PRODUCT_IDS.includes(productId) || GIFT_PRODUCT_IDS.includes(productId)) {
            remainingBundleItems.push({
              item: item,
              line: index + 1,
              id: item.key
            });
          }
        });
        
        if (remainingBundleItems.length > 0) {
          return removeItemsSequentiallyWithThemeAPI(remainingBundleItems);
        } else {
          // Finales Cart-Update Event
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: cart }
          }));
          
          // Finale Cart-Drawer Aktualisierung
          return fetch(`${window.themeVariables?.routes?.cartChangeUrl || '/cart/change'}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              sections: ['mini-cart']
            })
          })
          .then(response => response.json())
          .then(sectionsData => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { 
                cart: cart,
                sections: sectionsData.sections
              }
            }));
          })
          .catch(error => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart }
            }));
          });
        }
      });
  }

  // Intercept normale Remove-Buttons für Main-Products
  function interceptRemoveButtons() {
    document.addEventListener('click', function(event) {
      const removeButton = event.target.closest('a[href*="cart/change"], a[href*="url_to_remove"], .line-item__remove-button, .bundle-remove-button');
      
      if (!removeButton) return;
      
      const href = removeButton.getAttribute('href');
      let lineIndex = null;
      let isRemoveAction = false;
      
      if (href) {
        if (href.includes('url_to_remove')) {
          const match = href.match(/line=(\d+)/);
          if (match) {
            lineIndex = parseInt(match[1]) - 1;
            isRemoveAction = true;
          }
        }
        else if (href.includes('cart/change') && href.includes('quantity=0')) {
          const idMatch = href.match(/id=([^&:]+)/);
          if (idMatch) {
            const variantId = idMatch[1];
            isRemoveAction = true;
            
            event.preventDefault();
            event.stopPropagation();
            
            findLineIndexByVariantId(variantId, removeButton, href);
            return;
          }
        }
      }
      
      if (isRemoveAction && lineIndex !== null) {
        event.preventDefault();
        event.stopPropagation();
        
        checkAndHandleBundle(lineIndex, removeButton, href);
        return;
      }
    });
  }
  
  // Finde Line-Index über Variant-ID
  function findLineIndexByVariantId(variantId, removeButton, fallbackHref) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const lineIndex = cart.items.findIndex(item => {
          const itemVariantId = item.variant_id.toString();
          const itemKey = item.key || `${item.variant_id}:${item.properties ? Object.keys(item.properties).map(k => `${k}=${item.properties[k]}`).join(',') : ''}`;
          
          return itemVariantId === variantId || itemKey.startsWith(variantId);
        });
        
        if (lineIndex !== -1) {
          checkAndHandleBundle(lineIndex, removeButton, fallbackHref);
        } else {
          window.location.href = fallbackHref;
        }
      })
      .catch(error => {
        window.location.href = fallbackHref;
      });
  }
  
  // Prüfe ob Bundle und handle entsprechend
  function checkAndHandleBundle(lineIndex, removeButton, fallbackHref) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (!cart.items[lineIndex]) {
          window.location.href = fallbackHref;
          return;
        }
        
        const item = cart.items[lineIndex];
        const productId = item.product_id.toString();
        
        if (MAIN_PRODUCT_IDS.includes(productId)) {
          if (isBundleInCart(cart)) {
            removeAllBundleItems();
          } else {
            window.location.href = fallbackHref;
          }
        } else {
          window.location.href = fallbackHref;
        }
      })
      .catch(error => {
        window.location.href = fallbackHref;
      });
  }

  // Initialisierung
  function init() {
    interceptRemoveButtons();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();